import { createContext, useContext } from "react";
import type { Session } from "@supabase/supabase-js";

export interface AuthSessionContextType {
  session: Session | null;
  setSession: React.Dispatch<React.SetStateAction<Session | null>>;
  refreshSession: () => Promise<void>;
  userRole: string | null;
  isLoading: boolean; // Add loading state to context
}

export const AuthSessionContext = createContext<AuthSessionContextType | undefined>(undefined);

export function useAuthSession() {
  const context = useContext(AuthSessionContext);
  if (context === undefined) {
    throw new Error('useAuthSession must be used within an AuthSessionProvider');
  }
  return context;
}
